"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SessionHelperService = void 0;
var store_1 = require("./store");
var url_1 = require("../../core/url");
var local_storage_1 = require("../../core/local-storage");
var model_1 = require("./model");
var http_1 = require("../../core/http");
var operators_1 = require("rxjs/operators");
var session_api_1 = require("./session.api");
var session_service_1 = require("./session.service");
var basket_1 = require("../basket");
var rxjs_1 = require("rxjs");
var cookie_1 = require("../../core/cookie");
var Cookies = require("js-cookie");
var env_1 = require("../../env");
var fetchUpdateSessionSorting$;
var setLoadingInSession = function (state) { return store_1.SessionStore.setLoading(state); };
var getSessionIdFromStorage = function (paramsSession) {
    try {
        return JSON.parse(paramsSession);
    }
    catch (e) {
        return undefined;
    }
};
var getSessionIdFromParams = function () {
    var params = url_1.Url.getParamsInQueryString();
    return getSessionIdFromStorage(params.fusionId);
};
var getSessionFromLocalStorage = function () {
    var localStorageSessionString = local_storage_1.LocalStorage.get(url_1.UrlValue.S);
    return getSessionIdFromStorage(localStorageSessionString);
};
var getSessionFromCookie = function () {
    // const cookieSessionString = Cookie.getParamsInCookie();
    // return getSessionIdFromStorage(cookieSessionString);
    // FIX jo&joe cookie recuperato male
    return Cookies.get(env_1.Env.SessionIdCookieKey);
};
var removeSessionIdFromCookie = function () {
    Cookies.remove(env_1.Env.SessionIdCookieKey, { path: '' });
};
var isUUID = function (s) {
    var match = s.match('^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$');
    return match !== null;
};
var storeSession = function (session) {
    store_1.SessionStore.update(session);
    window.QW_HOTEL_ENV.ALLOW_QUERY_STRING_SESSION_ID && url_1.Url.setParamInQueryString(url_1.UrlValue.S, JSON.stringify(session.sessionId));
    if (isUUID(session.sessionId)) {
        cookie_1.Cookie.setParamInCookie(url_1.UrlValue.S, session.sessionId);
    }
    local_storage_1.LocalStorage.set(url_1.UrlValue.S, session.sessionId);
    setLoadingInSession(false);
};
var onErrorInvalidSession = function (err) {
    setLoadingInSession(false);
    if (isInvalidSession(err)) {
        return createNewSession();
    }
    return http_1.Http.error(err);
};
var isInvalidSession = function (err) {
    return http_1.Http.isInvalidSessionResponse(err) || http_1.Http.isNotAcceptableResponse(err);
};
var fetchSessionAndHandleInvalidError = function (id) {
    return session_service_1.SessionService.fetchSession(id).pipe(operators_1.catchError(function (err) {
        return onErrorInvalidSession(err);
    }));
};
var fetchUpdateSessionContext = function (sessionId, body) {
    var updatedBody = model_1.SessionHelper.addPromoCodeFromLocalStorage(body);
    return http_1.Http.patch(session_api_1.SessionApi.updateContext(sessionId), updatedBody);
};
var fetchUpdateSessionDisplay = function (sessionId, body) {
    return http_1.Http.patch(session_api_1.SessionApi.updateDisplay(sessionId), body);
};
var fetchUpdateSessionSorting = function (sessionId, body) {
    if (!fetchUpdateSessionSorting$) {
        fetchUpdateSessionSorting$ = http_1.Http.patch(session_api_1.SessionApi.updateSorting(sessionId), body)
            .pipe(operators_1.share());
    }
    return fetchUpdateSessionSorting$;
};
var fetchUpdateSessionContextWithNotEmptyBasket = function (body, session) {
    return basket_1.BasketService.fetchDeleteBasket(session.sessionId).pipe(operators_1.switchMap(function () { return fetchUpdateSessionContext(session.sessionId, body); }), operators_1.switchMap(function () { return basket_1.BasketService.fetchBasket(session); }));
};
var createNewSession = function (body) {
    if (body === void 0) { body = {}; }
    var updatedContex = model_1.SessionHelper.addPromoCodeFromLocalStorage(body.context);
    var updatedBody = __assign(__assign({}, body), { context: updatedContex });
    setLoadingInSession(true);
    return session_service_1.SessionService.fetchCreateSession(updatedBody).pipe(operators_1.switchMap(function (sessionCreated) {
        return rxjs_1.zip(rxjs_1.of(sessionCreated.sessionId), fetchUpdateSessionSorting(sessionCreated.sessionId, { sortType: model_1.SessionSortType.AscendingPrice }));
    }), operators_1.switchMap(function (_a) {
        var sessionId = _a[0];
        return session_service_1.SessionService.fetchSession(sessionId);
    }), operators_1.catchError(function (err) { return rxjs_1.throwError(err); }));
};
exports.SessionHelperService = {
    setLoadingInSession: setLoadingInSession,
    getSessionIdFromParams: getSessionIdFromParams,
    getSessionFromLocalStorage: getSessionFromLocalStorage,
    getSessionFromCookie: getSessionFromCookie,
    removeSessionIdFromCookie: removeSessionIdFromCookie,
    storeSession: storeSession,
    fetchSessionAndHandleInvalidError: fetchSessionAndHandleInvalidError,
    fetchUpdateSessionContext: fetchUpdateSessionContext,
    fetchUpdateSessionContextWithNotEmptyBasket: fetchUpdateSessionContextWithNotEmptyBasket,
    fetchUpdateSessionDisplay: fetchUpdateSessionDisplay,
    createNewSession: createNewSession,
    isInvalidSession: isInvalidSession
};
//# sourceMappingURL=session-helper.service.js.map